import Route from 'cio/routes/base';
import SetupGuide from 'cio/models/setup-guide';
import { MessagingChannelType } from 'cio/utils/setup-guide/messaging-channels';

export default class SetupGuideChannelsWebhook extends Route {
  crumb() {
    return {
      name: 'Webhook',
      path: 'setup-guide.channels.webhook',
    };
  }

  redirect(model: SetupGuide) {
    if (model.messagingChannelTypes.includes(MessagingChannelType.Webhook)) {
      return;
    }

    this.router.transitionTo('setup-guide.channels');
  }
}
